import Constant from '@/common/constant/Constant';
import { onSubmitApproveExternalCustomerRequest } from '@/component/chatThread/handler/DetailTicketHandler';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { I18n } from 'aws-amplify';

export const DialogConfirmApproveRejectTicket = props => {
    const { isOpen, setIsOpen } = props;
    let msgCode = '';

    switch (props.selectedApproveFlag) {
        case Constant.APPROVE_FLAG.APPROVE:
            msgCode = 'USER04MSG026';
            break;
        case Constant.APPROVE_FLAG.REJECTED:
            msgCode = 'USER04MSG027';
            break;
        default:
            break;
    }

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setSelectedApproveFlag('');
        setIsOpen(false);
    };

    const onSubmitEditTicket = () => {
        props.submitApproveReject(props.selectedApproveFlag, props);
        props.setSelectedApproveFlag('');
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content" id="alert-dialog-delete-addition-user-content">
                    {I18n.get(msgCode)}
                </div>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onSubmitEditTicket}
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="btn-handle-delete-user btn-handle-delete-user-disagree"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
